const plzInput = document.querySelector('input[name="plz_schule"]');

if(plzInput) {
    const neutralHint = 'Bitte trage die PLZ deiner Schule ein, um zu überprüfen, ob sie im Geschäftsgebiet einer teilnehmenden Mitgliedsbank liegt.';
    const resultContainer = document.createElement('div');
    resultContainer.className = 'form-info plz-check-result';
    plzInput.insertAdjacentElement('afterend', resultContainer);

    let debounceTimer;

    const showNeutral = () => {
        resultContainer.textContent = neutralHint;
        resultContainer.classList.remove('is-success', 'is-error');
    };

    const checkPlz = () => {
        const value = plzInput.value.trim();

        if(!/^\d{5}$/.test(value)) {
            showNeutral();
            return;
        }

        fetch(`${window.location.pathname}?action=check-plz&plz=${encodeURIComponent(value)}`)
            .then((response) => response.json())
            .then((data) => {
                resultContainer.classList.toggle('is-success', !!data.found);
                resultContainer.classList.toggle('is-error', !data.found);
                resultContainer.textContent = data.message || '';
            })
            .catch(() => {
                showNeutral();
            });
    };

    plzInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(checkPlz, 400);
    });

    showNeutral();
}
